import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AOS from 'aos';

import 'aos/dist/aos.css';

const Img = styled.img`
	height: 100%;

	@supports (object-fit: contain) {
		width: 100%;
		object-fit: contain;
	}
`;

class Image extends PureComponent {
	componentDidMount() {
		AOS.init();
		AOS.refresh();
	}

	componentDidUpdate() {
		AOS.refresh();
	}

	render() {
		const { src, alt } = this.props;
		return (
			<Img
				src={src}
				alt={alt}
				data-aos="fade-down"
				data-aos-easing="linear"
				data-aos-duration="900"
				data-aos-once="false"
			/>
		);
	}
}

Image.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image.js